import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import { services } from "../data/services";
import NotFound from "./NotFound";

const ServiceDetails = () => {
  const { id } = useParams();
  const [active, setActive] = useState(true);
  const [service, setService] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setActive(false);
      const foundService = services.find(s => s.id === parseInt(id));
      setService(foundService);
    }, 500);
  }, [id]);

  if (active) {
    return <Preloader />;
  }

  if (!service) {
    return <NotFound />;
  }

  return (
    <>
      <HelmetReact title={`${service.title} | Service Details`} />

      <HeaderThree />

      <Breadcrumb title={service.title} />

      <section className="space">
        <div className="container">
          <div className="row gx-30">
            <div className="col-xxl-8 col-lg-7">
              <div className="page-thumb">
                <img src={service.details.mainImage} alt={service.title} />
              </div>
              <ul className="service-details-list">
                <li className="single-service-list">
                  <span className="title">Category</span>
                  <h6 className="content">{service.category}</h6>
                </li>
                <li className="single-service-list">
                  <span className="title">Clients</span>
                  <h6 className="content">{service.clients}</h6>
                </li>
                <li className="single-service-list">
                  <span className="title">Timeframe</span>
                  <h6 className="content">{service.timeframe}</h6>
                </li>
              </ul>
              <h3 className="page-title mt-40 mb-20">{service.title}</h3>
              {service.details.content.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}

              <div className="checklist style6 mt-40 mb-60">
                <ul>
                  {service.details.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="row gy-4">
                {service.details.secondaryImages.map((image, index) => (
                  <div className="col-lg-6" key={index}>
                    <div className="page-thumb style2">
                      <img src={image} alt={`${service.title} ${index + 1}`} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-xxl-4 col-lg-5">
              <aside className="sidebar-area">
                <div className="widget widget_categories widget_service-categories">
                  <h3 className="widget_title">Our Services</h3>
                  <ul>
                    {services.map((s) => (
                      <li key={s.id}>
                        <Link to={`/service-details/${s.id}`}>{s.title}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default ServiceDetails;